import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import getRatings from './getRatings';
import { useOnErrorHandler } from '../../../common';
import env from '../../../../config/env';

const INTERVAL = env.RATING_INTERVAL;

function useGetRatings(enabled = true) {
  const { username } = useSelector((store) => store.auth);

  const query = useQuery({
    queryKey: ['getRatings'],
    queryFn: () => getRatings({ idClouder: username }),
    enabled,
    refetchInterval: parseInt(INTERVAL),
    refetchIntervalInBackground: true,
  });

  useOnErrorHandler({ query });

  return query;
}

export default useGetRatings;
